$(document).on("change", ".radios-holder input", function() {
  const $this = $(this);
  const thisVal = $this.val();
  const $parent = $this.parent();
  const $radiosHolder = $this.closest(".radios-holder");
  const $hoverItem = $radiosHolder.find(".hover-item");
  const itemPositionTop = $parent.position().top;
  const itemPositionLeft = $parent.position().left;
  const $colorNameHolder = $radiosHolder.find(".color-name");

  $hoverItem.addClass("active").css({
    top: itemPositionTop - 4,
    left: itemPositionLeft - 4
  });

  if ($colorNameHolder.length) {
    $colorNameHolder.text(thisVal);
  }
});



// WEBPACK FOOTER //
// ../assets/js/radio-hover.js